module.exports = __webpack_public_path__ + "img/logo.d951d378.png";